import { createSlice } from '@reduxjs/toolkit';

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    totalRows: 0,
    loading: false,
    error: null,
  },
  reducers: {
    fetchUsersStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchUsersSuccess(state, action) {
      state.loading = false;
      state.users = action.payload.users;
      state.totalRows = action.payload.totalRows;
    },
    fetchUsersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateUserSuccess(state, action) {
      const updatedUser = action.payload;
      const index = state.users.findIndex(user => user._id === updatedUser._id || user.id === updatedUser._id);
      if (index !== -1) {
        state.users[index] = { ...state.users[index], ...updatedUser };
      }
    },
    addUserSuccess(state, action) {
      state.users.unshift(action.payload);
      state.totalRows = state.totalRows + 1;
    },
    // ✅ Reset loading state
    resetLoading(state) {
      state.loading = false;
    }
  },
});

export const { 
  fetchUsersStart, 
  fetchUsersSuccess, 
  fetchUsersFailure,
  deleteUserSuccess,
  bulkDeleteUsersSuccess,
  updateUserSuccess,
  addUserSuccess,
  resetLoading
} = usersSlice.actions;

export default usersSlice.reducer;